<template>
  <section class="parceiros-container rounded-default p-4">
    <div class="flex flex-row mb-5 justify-between">
      <span class="partners-title">{{ data.titulo }}</span>
      <span class="btn-edit flex justify-center items-center justify-center rounded-default">
        <span class="edit-icon cursor-pointer" @click="$emit('selected', data.id)">
          <feather type="edit-2" size="12px" />
        </span>

        <b-dropdown id="drop" class="trigger-dropdown" position="is-bottom-left" aria-role="list">
          <template #trigger>
            <div class="flex items-center justify-center">
              <feather class="actions-icon" type="chevron-down" size="14px" />
            </div>
          </template>

          <b-dropdown-item class="list-item">
            <span class="k-dropdown-item flex flex-row items-center justify-center" @click="dropdownActions(data)">
              <span class="list-item-text">Deletar</span>
              <feather class="trash-icon" type="trash-2" size="14px" />
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </span>
    </div>
  </section>
</template>

<script>
import global from '@/mixins/global';

export default {
	name: 'Grupo',
	mixins: [global],
	props: {
		data: {
			type: Object,
			required: true,
			default: () => ({}),
		},
	},
	data() {
		return {};
	},
	watch: {},
	methods: {
		dropdownActions(value) {
			this.$emit('dropdown-action', {
				action: 'delete',
				data: value,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/style/Global.css';

.parceiros-container {
	background-color: var(--white-color);
	box-sizing: border-box;
	width: 24%;
	margin-bottom: 40px;
	transition: ease-in-out 0.2s;
	flex-wrap: wrap;
	border: 2px solid var(--white-color);
}

.btn-edit {
	background-color: var(--secondary-color);
	height: 25px;
}

.trigger-dropdown,
.edit-icon {
	width: 25px;
	height: 20px;
	transition: ease-in-out 0.2s;
	display: flex;
	align-items: center;
	justify-content: center;
	&:hover {
		background-color: darken(#e2eaf5, 10%);
	}
}

.trash-icon {
	margin-left: 2px;
	color: #e63946;
}

.parceiros-container:hover {
	box-shadow: var(--default-shadow);
}

.list-item {
	display: flex;
	align-items: center;
	justify-content: center;
}

.partners-title {
	font-weight: bold;
	font-size: 14px;
	color: #010101;
}
.list-item-text {
	font-size: 12px;
	font-weight: bold;
	color: #666666;
}
.k-dropdown-item {
	width: 100%;
	height: 100%;
}
</style>
